"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DefaultLink = _interopRequireDefault(require("./Defaults/DefaultLink"));
var _DefaultTitle = _interopRequireDefault(require("./Defaults/DefaultTitle"));
var _SideMenuFactory = _interopRequireDefault(require("./Factory/SideMenuFactory"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function _() {
  var styles = ".SideMenu {\n  position: absolute;\n  min-width: 15.625rem;\n  max-width: 15.625rem;\n  min-height: 100vh;\n  min-height: 100dvh;\n  top: 0;\n  left: 100vw;\n  transition: transform 0.15s ease-in-out, visibility 0.15s ease-in-out;\n  cursor: pointer;\n  background: linear-gradient(to right, black 0, #444 0.25rem, #444 100%);\n}\n.SideMenu > * {\n  display: block;\n}\n.SideMenu::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: -100vw;\n  min-height: 100vh;\n  min-height: 100dvh;\n  min-width: 100vw;\n  min-width: 100dvw;\n  transition: background-color 0.15s ease-in-out;\n}\n.SideMenu__no-container__freeze {\n  visibility: visible;\n}\n.SideMenu__no-container__freeze::before {\n  background-color: rgba(0, 0, 0, 0.5);\n  pointer-events: all;\n}\n.SideMenu__no-container__closed {\n  transform: translateX(0);\n  visibility: hidden;\n}\n.SideMenu__no-container__closed::before {\n  transition: background-color 0.15s ease-in-out;\n  background-color: rgba(0, 0, 0, 0);\n  visibility: hidden;\n  z-index: -10;\n  pointer-events: none;\n}\n.SideMenu__no-container__open {\n  transform: translateX(-15.625rem);\n  visibility: visible;\n}\n.SideMenu__no-container__open::before {\n  background-color: rgba(0, 0, 0, 0.5);\n  pointer-events: all;\n}\n.SideMenu__focus-trap {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  color: transparent;\n}";
  var fileName = "SideMenu_SideMenu";
  var element = document.querySelector("style[data-sass-component='SideMenu_SideMenu']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var MemoizedSideMenuContent = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var data = _ref.data,
    _ref$TitleComponents = _ref.TitleComponents,
    TitleComponents = _ref$TitleComponents === void 0 ? [_DefaultTitle["default"]] : _ref$TitleComponents,
    _ref$LinkComponents = _ref.LinkComponents,
    LinkComponents = _ref$LinkComponents === void 0 ? [_DefaultLink["default"]] : _ref$LinkComponents;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _SideMenuFactory["default"])(data, TitleComponents, LinkComponents, 'SideMenu__link')
  });
});
var SideMenu = function SideMenu(_ref2) {
  var open = _ref2.open,
    createSideMenu = _ref2.createSideMenu,
    _ref2$TitleComponents = _ref2.TitleComponents,
    TitleComponents = _ref2$TitleComponents === void 0 ? [_DefaultTitle["default"]] : _ref2$TitleComponents,
    _ref2$LinkComponents = _ref2.LinkComponents,
    LinkComponents = _ref2$LinkComponents === void 0 ? [_DefaultLink["default"]] : _ref2$LinkComponents,
    setOpen = _ref2.setOpen,
    className = _ref2.className,
    _ref2$freeze = _ref2.freeze,
    freeze = _ref2$freeze === void 0 ? false : _ref2$freeze;
  var focusables = document.getElementsByClassName('SideMenu__link');
  var maxLeng = focusables.length - 1;
  var shifted = false;
  (0, _react.useEffect)(function () {
    var body = document.getElementsByTagName('body')[0];
    if (open) {
      body.classList.add('SideMenu__page');
      var sec = document.getElementsByClassName('SideMenu__focus-trap')[0];
      var focusOnTrap = function focusOnTrap() {
        // @ts-ignore
        sec == null ? void 0 : sec.focus({
          preventScroll: true
        });
      };
      focusOnTrap();
      var keyDownFunc = function keyDownFunc(e) {
        if (e.code === 'Tab') {
          if (e.shiftKey) {
            shifted = true;
            if (document.activeElement === focusables[0]) {
              focusOnTrap();
            }
          } else {
            shifted = false;
            if (document.activeElement === focusables[maxLeng]) {
              focusOnTrap();
            }
          }
        }
      };
      body.addEventListener('keydown', keyDownFunc);
      return function () {
        return body.removeEventListener('keydown', keyDownFunc);
      };
    } else {
      body.classList.remove('SideMenu__page');
    }
  });
  var focusTrapBlurHandler = (0, _react.useCallback)(function (num) {
    // @ts-ignore
    focusables[num].focus({
      preventScroll: true
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [open && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "SideMenu__focus-trap",
      tabIndex: -1,
      onBlur: function onBlur() {
        if (shifted) {
          focusTrapBlurHandler(maxLeng);
        } else {
          focusTrapBlurHandler(0);
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (e.code === 'Escape') {
          setOpen(false);
        }
      },
      "aria-hidden": true,
      children: "Focus Trap"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("aside", {
      className: "SideMenu ".concat(open ? freeze ? 'SideMenu__no-container__freeze' : 'SideMenu__no-container__open' : 'SideMenu__no-container__closed', " ").concat(className || ''),
      onKeyDown: function onKeyDown(e) {
        if (e.code === 'Escape') {
          setOpen(false);
        }
      },
      onClick: function onClick() {
        return setOpen(false);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MemoizedSideMenuContent, {
        data: createSideMenu,
        TitleComponents: TitleComponents,
        LinkComponents: LinkComponents
      })
    })]
  });
};
var _default = SideMenu;
exports["default"] = _default;